import { createSlice } from "@reduxjs/toolkit";

export const myRole = createSlice({
  name: "myRole",
  initialState: {
    value: { myRole: "", customClaims: "", resourcesArray: [] },
  },
  reducers: {
    updateUserPermissions: (state, action) => {
      state.value.myRole = action.payload?.role;
      state.value.customClaims = action.payload?.claims;
      state.value.resourcesArray = action.payload?.resourcesArray;
    },
    updateRole: (state, action) => {
      state.value.myRole = action.payload?.role;
    },
    updateClaims: (state, action) => {
      state.value.customClaims = action.payload?.claims;
    },
    updateResourceArray: (state, action) => {
      state.value.resourcesArray = action.payload?.resourcesArray;
    },
    resetRole: (state, action) => {
      state.value = { myRole: "", customClaims: "", resourcesArray: [] };
    },
  },
});

export const {
  updateUserPermissions,
  updateRole,
  updateClaims,
  updateResourceArray,
  resetRole,
} = myRole.actions;

export default myRole.reducer;
